"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParserOptions = void 0;
const lodash_escaperegexp_1 = __importDefault(require("lodash.escaperegexp"));
const lodash_isnil_1 = __importDefault(require("lodash.isnil"));
class ParserOptions {
  escapedDelimiter;
  objectMode = true;
  delimiter = ',';
  ignoreEmpty = false;
  quote = '"';
  escape = null;
  escapeChar = this.quote;
  comment = null;
  supportsComments = false;
  ltrim = false;
  rtrim = false;
  trim = false;
  headers = null;
  renameHeaders = false;
  strictColumnHandling = false;
  discardUnmappedColumns = false;
  carriageReturn = '\r';
  NEXT_TOKEN_REGEXP;
  encoding = 'utf8';
  limitRows = false;
  maxRows = 0;
  skipLines = 0;
  skipRows = 0;
  constructor(opts) {
    Object.assign(this, opts || {});
    if (this.delimiter.length > 1) {
      throw new Error('delimiter option must be one character long');
    }
    this.escapedDelimiter = (0, lodash_escaperegexp_1.default)(this.delimiter);
    this.escapeChar = this.escape ?? this.quote;
    this.supportsComments = !(0, lodash_isnil_1.default)(this.comment);
    this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`);
    if (this.maxRows > 0) {
      this.limitRows = true;
    }
  }
}
exports.ParserOptions = ParserOptions;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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